<template>
  <v-card outlined>
    <v-data-table
      :items="list"
      :headers="headers"
      :loading="loading"
      disable-pagination
      hide-default-footer
      :sort-by="['createdDate']"
      :sort-desc="[true]"
      class="row-pointer"
      mobile-breakpoint="0"
      @click:row="rowClick"
    >
      <template #[`item.available`]="{ item }">
        <v-icon
          small
          :color="item.available ? 'success' : 'error'"
        >
          check_circle
        </v-icon>
      </template>
      <template #[`item.createdDate`]="{ item }">
        {{ item.createdDate | normalDate }}
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'DesignersList',
  components: { },
  data: () => {
    return {
      headers: [
        { text: 'Available', value: 'available' },
        { text: 'Name', value: 'fullName' },
        { text: 'Created', value: 'createdDate' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      list: 'users/list'
    })
  },
  mounted() {
    this.$store.dispatch('users/reset');
    this.loading = true;
    this.$store
      .dispatch('users/getDesigners')
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowClick(item) {
      this.$router.push({ path: `/users/${item.id}` });
    }
  }
};
</script>
